import { HttpClient, HttpContext, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { constants } from 'buffer';
import { url } from 'inspector';
import { Observable, of } from 'rxjs';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError, map } from 'rxjs/operators';
import { Constants } from 'src/app/domain/const/constants';
import { BYPASS_JW_TOKEN } from 'src/app/interceptors/loadinginterceptor';
import { IncidentByEventIdFilterDto, IncidentFilterDto, LastestAlertsFilterDto } from 'src/app/interfaces/Dtos/IncidentFilter.dto';
import { LandingPageDto } from 'src/app/interfaces/Dtos/landing-page.dto';
import { storageApiDto } from 'src/app/interfaces/Dtos/storage-api.dto';
import { IIncidentTypeResponse } from 'src/app/interfaces/Responses/IIncidentsTypesResponse';
import { ISitesResponse } from 'src/app/interfaces/Responses/ISitesResponse';
import { LandingPageDtoRequest } from 'src/app/interfaces/requests/landing-page-dto';
import { environment } from 'src/environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ControltowerService {
    //private apiUrl = '/api/?format=jsonp&callback=JSONP_CALLBACK';
    private apiUrl = '/api?format=jsonp';
    private apiUrlip = 'https://ipinfo.io';
    typesId: string = '5,8,38,39,40,41,42,43,44,45,51,52,56'

    constructor(private http: HttpClient) { }

    getAuthIndustrialToken(apiName: string, clientId: string) {
        const params = new HttpParams()
            .set(Constants.API_NAME, apiName)

        const headers = new HttpHeaders({
            'client_id': clientId,
        });



        return this.http.get<IIncidentTypeResponse>(`${environment.urlAuth}${Constants.GET_AUTH_TOKEN}`, { params: params, headers: headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }



    getIncidents(filters: IncidentFilterDto) {

        const headers = { 'content-type': 'application/json' }
        const body = JSON.stringify(filters);
        return this.http.post(`${environment.urlBaseService}${Constants.INCIDENTS}`, body, { 'headers': headers })
    }

    getIncidentsByEvent(filters: IncidentByEventIdFilterDto) {

        const headers = { 'content-type': 'application/json' }
        const body = JSON.stringify(filters);
        return this.http.post(`${environment.urlBaseService}${Constants.INCIDENTS_BY_EVENT}`, body, { 'headers': headers })
    }


    getLatestAlerts(filters: LastestAlertsFilterDto) {
        const headers = { 'content-type': 'application/json' }
        const body = JSON.stringify(filters);
        return this.http.post(`${environment.urlBaseService}${Constants.LASTES_ALERTS}`, body, { 'headers': headers })
    }

    getLatestAlertImages(filters: number[], access_token: string) {
        const headers = new HttpHeaders({
            'content-type': 'application/json',
            'Authorization': 'Bearer ' + access_token,
        });

        const body = JSON.stringify(filters);
        return this.http.post(`${environment.urlStorageApi}${Constants.LASTES_ALERTS_IMAGES}`, body, { 'headers': headers })
    }

    getIncidentsTypes(localCode: string) {

        const params = new HttpParams()
            .set(Constants.LOCALE_CODE_OLD, localCode)

        return this.http.get<IIncidentTypeResponse>(`${environment.urlBaseService}${Constants.INCIDENTS_TYPES}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }

    getUsedIncidentsTypes(request: any) {

        const headers = { 'content-type': 'application/json' }
        const body = JSON.stringify(request);

        return this.http.post<any>(`${environment.urlBaseService}${Constants.USED_INCIDENTS_TYPES}`, body, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }

    getSites() {
        return this.http.get<ISitesResponse>(`${environment.urlBaseService}${Constants.SITES}`)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }

    getStorageApiBySite(filters: storageApiDto) {

        const headers = { 'content-type': 'application/json' }
        const body = JSON.stringify(filters);
        return this.http.post(`${environment.urlBaseService}${Constants.GET_STORAGE_API_BY_PARAM_BY_SITE_OR_DEFAULT}`, body, { 'headers': headers })
    }

    getIncidentsStatus(localCode: string) {

        const params = new HttpParams()
            .set(Constants.LOCALE_CODE_OLD, localCode)
            .set(Constants.ATTRIBUTE_TYPE, this.typesId)

        return this.http.get<any>(`${environment.urlBaseService}${Constants.INCIDENT_STATUS}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }

    getAttributeValue(localCode: string) {

        const params = new HttpParams()
            .set(Constants.LOCALE_CODE_OLD, localCode)
            .set(Constants.ATTRIBUTE_TYPE, this.typesId)

        return this.http.get<any>(`${environment.urlBaseService}${Constants.GENERIC_ATTRIBUTE_VALUE}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }

    SaveFormIncident(request: any) {

        const body = JSON.stringify(request);
        console.log('body enviado', JSON.stringify(request))


        const headers = { 'content-type': 'application/json' }
        return this.http.post<any>(`${environment.urlBaseService}${Constants.SAVE_INCIDENT}`, body, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }



    SaveReportFieldsServices(request: any) {
        const body = JSON.stringify(request);
        console.log('body enviado', JSON.stringify(request))


        const headers = { 'content-type': 'application/json' }
        return this.http.post<any>(`${environment.urlBaseService}${Constants.SAVE_REPORT_FIELDS}`, body, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )

    }

    SaveMonitoringPerformance(request: any) {
        const body = JSON.stringify(request);
        console.log('body enviado', JSON.stringify(request))


        const headers = { 'content-type': 'application/json' }
        return this.http.post<any>(`${environment.urlBaseService}${Constants.SAVE_MONITORING_PERFORMANCE}`, body, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )

    }

    getDeviceManagement(localCode: string, siteId: string) {
        const params = new HttpParams()
            .set(Constants.LOCALE_CODE, localCode)
            .set(Constants.SITES_ID, siteId)
            .set(Constants.DEVICES, '500,502')




        return this.http.get<any>(`${environment.urlBaseService}${Constants.DEVICES_MANAGEMENT}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )


    }

    getSourcesDevices(localeCode: string, sites: string) {
        const params = new HttpParams()
            .set(Constants.LOCALE_CODE, localeCode)
            .set(Constants.SITES_ID, sites)


        return this.http.get<any>(`${environment.urlBaseService}${Constants.DEVICES_SOURCES}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )


    }


    getCatalogeSourcesDevices(localeCode: string, sites: string) {
        const params = new HttpParams()
            .set(Constants.LOCALE_CODE, localeCode)
            .set(Constants.SITES_ID, sites)


        return this.http.get<any>(`${environment.urlBaseService}${Constants.CATALOGE_GET_DEVICES_SOURCES}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )


    }

    getClientsByUserName() {



        return this.http.get<any>(`${environment.urlBaseService}${Constants.GET_CLIENTS}`)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )


    }

    getServiceDeviceReview(request: any) {


        const body = JSON.stringify(request);
        console.log('body enviado', JSON.stringify(request))


        const headers = { 'content-type': 'application/json' }
        return this.http.post<any>(`${environment.urlBaseService}${Constants.GET_DEVICE_SERVICE_REVIEW}`, body, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )

    }

    getPerformanceMonitoring(request: any) {
        const body = JSON.stringify(request);
        console.log('body enviado', JSON.stringify(request))


        const headers = { 'content-type': 'application/json' }
        return this.http.post<any>(`${environment.urlBaseService}${Constants.GET_PERFORMANCE_MONITORING}`, body, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )

    }

    UpdateFieldsServicesReview(request: any) {
        const body = JSON.stringify(request);
        console.log('body enviado', JSON.stringify(request))


        const headers = { 'content-type': 'application/json' }
        return this.http.post<any>(`${environment.urlBaseService}${Constants.UPDATE_REPORT_FIELDS}`, body, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }

    rejectIncident(EventId: number, RejectReasonId: number, Description: string, UserName: string) {
        const headers = { 'content-type': 'application/json' }
        return this.http.post(`${environment.urlBaseService}${Constants.REJECT_INCIDENT}?EventId=${EventId}&RejectReasonId=${RejectReasonId}&Description=${Description}&UserName=${UserName}`, '')
    }

    getSitesForLandingPage() {
        const params = new HttpParams()

        return this.http.get<any>(`${environment.urlBaseService}${Constants.GET_SITES_FOR_LANDING_PAGE}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )


    }


    getLandingPageInfo(request: LandingPageDtoRequest) {

        const headers = { 'content-type': 'application/json' }
        const body = JSON.stringify(request);
        return this.http.post(`${environment.urlBaseService}${Constants.GET_LANDING_PAGE}`, body, { 'headers': headers })

    }

    getDevicesAvailabilityInfo(paramDto: any) {

        console.log("paramDto enviado", paramDto)
        const headers = { 'content-type': 'application/json' }
        const body = JSON.stringify(paramDto);

        return this.http.post(`${environment.urlBaseService}${Constants.GET_AVAILABILITY_DEVICES}`, body, { 'headers': headers })
    }


    SaveSourceDeviceAlert(request: any) {
        const body = JSON.stringify(request);

        const headers = { 'content-type': 'application/json' }
        return this.http.post<any>(`${environment.urlBaseService}${Constants.SAVE_SOURCE_DEVICE_ALERT}`, body, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )

    }



    SaveAlertNotification(request: any) {
        const body = JSON.stringify(request);

        const headers = { 'content-type': 'application/json' }
        return this.http.post<any>(`${environment.urlBaseService}${Constants.SAVE_ALERT_NOTIFICATION}`, body, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )

    }












    SaveConfigurationAlert(request: any) {
        const body = JSON.stringify(request);
        console.log('body enviado', JSON.stringify(request))


        const headers = { 'content-type': 'application/json' }
        return this.http.post<any>(`${environment.urlBaseService}${Constants.SAVE_CONFIGURATION_ALERT}`, body, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )

    }



    GetEventTypes(localeCode: string): Observable<any> {


        return this.http.get<any>(`${environment.urlBaseService}${Constants.GET_EVENT_TYPES}?localeCode=${localeCode}`)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }


    DeleteSourceDeviceAlerts(id: any) {
        const headers = { 'content-type': 'application/json' }
        return this.http.delete<any>(`${environment.urlBaseService}${Constants.DELETE_SOURCE_DEVICE_ALERT}?Id=${id}`, { 'headers': headers })
    }

    DeleteAlertNotification(AlertNotificationId: any, sourceDeviceAlertId: any) {
        const headers = { 'content-type': 'application/json' }
        return this.http.delete<any>(`${environment.urlBaseService}${Constants.DELETE_ALERT_NOTIFICATION}?AlertNotificationId=${AlertNotificationId}&sourceDeviceAlertId=${sourceDeviceAlertId}`, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => ({
                        custom: true,
                        status: error.status,
                        message: mensajeError
                    }));
                })
            )

    }


    GetAllAcontacs() {


        return this.http.get<any>(`${environment.urlBaseService}${Constants.GET_CONTACS}`)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )

    }


    GetConfigurationsNotifications(site: number) {
        const params = new HttpParams()
            .set(Constants.siteId, site)


        return this.http.get<any>(`${environment.urlBaseService}${Constants.GET_NOTIFIATION_CONTIGURATION}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }



    GetConfigurationsAlerts(sourceDeviceId: number, localCode: string) {
        const params = new HttpParams()
            .set(Constants.sourceDeviceId, sourceDeviceId)
            .set(Constants.LOCALE_CODE, localCode)


        return this.http.get<any>(`${environment.urlBaseService}${Constants.GET_CONFIGURATIONS_ALERTS}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }


    saveConfigurationAlertDetail(request: any) {
        const body = JSON.stringify(request);
        console.log('body enviado', JSON.stringify(request))


        const headers = { 'content-type': 'application/json' }
        return this.http.post<any>(`${environment.urlBaseService}${Constants.SAVE_CONFIGURATION_ALERT_DETAIL}`, body, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }










    saveStopAlert(request: any) {

        if (request.incidentTypes[0] == 0) {
            request.incidentTypes.splice(0, 1);
        }

        const body = JSON.stringify(request);
        const headers = { 'content-type': 'application/json' }

        return this.http.post<any>(`${environment.urlBaseService}${Constants.SAVE_STOP_ALERT}`, body, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }

    getNotificationConfigurationBySites(request: any) {

        const headers = { 'content-type': 'application/json' }
        const body = JSON.stringify(request);

        return this.http.post<any>(`${environment.urlBaseService}${Constants.NOTIFICATIONS_BY_SITE}`, body, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }

    GetIsValidSeverityEventAlerts(eventTypeId: any[], severityTypeId: any[], sourceDeviceId: number) {
        let params = new HttpParams()
            //.set(Constants.eventTypeId, eventTypeId.toString())
            //.set(Constants.severityTypeId, severityTypeId.toString())
            .set(Constants.sourceDeviceId, sourceDeviceId)

        eventTypeId.forEach(type => {
            params = params.append('eventTypeId', JSON.stringify(type));
        });

        if (severityTypeId.length > 0) {
            severityTypeId.forEach(type => {
                params = params.append('severityTypeId', JSON.stringify(type));
            });
        }


        console.log('params enviado get is valid', { params })

        return this.http.get<any>(`${environment.urlBaseService}${Constants.VALIDATE_SEVERITY_EVENT}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )


    }


    DeleteSourceDevice(request: any) {

        const body = JSON.stringify(request);
        console.log('body enviado', JSON.stringify(request))


        const headers = { 'content-type': 'application/json' }
        return this.http.post<any>(`${environment.urlBaseService}${Constants.POST_DELETE_DEVICE}`, body, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )

    }

    GetConfigurationAlertByDeviceId(eventTypeId: number, severityTypeId: number, sourceDeviceId: number) {
        let params = new HttpParams()
            //.set(Constants.eventTypeId, eventTypeId.toString())
            //.set(Constants.severityTypeId, severityTypeId.toString())
            .set(Constants.sourceDeviceId, sourceDeviceId)
            .set(Constants.eventTypeId, eventTypeId.toString())
            .set(Constants.severityTypeId, severityTypeId.toString())



        console.log('params enviado obtiene detalle de configuracion alertas', { params })

        return this.http.get<any>(`${environment.urlBaseService}${Constants.GET_DETAIL_CONFIGURATION_ALERT}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )


    }

    getLocationsBySite(sites: string) {
        const params = new HttpParams()
            .set(Constants.SITES_ID, sites)

        console.log('params enviado', params)

        return this.http.get<any>(`${environment.urlBaseService}${Constants.GET_LOCATIONS}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )


    }


    SaveSourceDevice(request: any) {

        const body = JSON.stringify(request);
        console.log('body enviado', JSON.stringify(request))




        const headers = { 'content-type': 'application/json' }
        return this.http.post<any>(`${environment.urlBaseService}${Constants.POST_SAVE_DEVICE}`, body, { 'headers': headers })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }






    getIp(): Observable<any> {
        return this.http.get(this.apiUrl, {
            context: new HttpContext().set(BYPASS_JW_TOKEN, true)
        });
    }


    getIpInfo(ip: string): Observable<any> {
        return this.http.get(`${this.apiUrlip}/${ip}/json`, {
            context: new HttpContext().set(BYPASS_JW_TOKEN, true)
        }).pipe(
            catchError(error => {
                console.error('Error fetching IP info:', error);
                return of(null);
            })
        );
    }



    getLocalIp(): Promise<string[]> {
        return new Promise<string[]>((resolve, reject) => {
            const ips: string[] = [];
            const RTCPeerConnection = window.RTCPeerConnection || (window as any).mozRTCPeerConnection || (window as any).webkitRTCPeerConnection;
            if (!RTCPeerConnection) {
                reject('WebRTC not supported by this browser');
                return;
            }

            const pc = new RTCPeerConnection({
                iceServers: []
            });

            pc.createDataChannel('');
            pc.createOffer().then(offer => pc.setLocalDescription(offer)).catch(reject);

            pc.onicecandidate = (ice) => {
                if (!ice || !ice.candidate || !ice.candidate.candidate) return;
                const ipMatch = /([0-9]{1,3}\.){3}[0-9]{1,3}/.exec(ice.candidate.candidate);
                if (ipMatch) {
                    const ip = ipMatch[0];
                    if (!ips.includes(ip)) {
                        ips.push(ip);
                    }
                }
                if (ice.candidate.candidate.includes('typ host')) {
                    resolve(ips);
                    pc.onicecandidate = null;
                }
            };
        });
    }


    GetSourceDevicesByType(sourceDeviceTypeId: number, sitesId: string): Observable<any> {
        const params = new HttpParams()
            .set("sourceDeviceTypeId", sourceDeviceTypeId)
            .set("sitesId", sitesId)

        return this.http.get<any>(`${environment.urlBaseService}${Constants.GET_SOURCE_DEVICES_BY_TYPE}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }


    GetSourceDeviceAlertsBySourceDeviceId(sourceDeviceId: number, locale_code: string): Observable<any> {
        const params = new HttpParams()
            .set("sourceDeviceId", sourceDeviceId)
            .set("locale_code", locale_code)

        return this.http.get<any>(`${environment.urlBaseService}${Constants.GET_SOURCE_DEVICE_ALERT_BY_SOURCE_DEVICE_ID}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }


    GetSourceDeviceAlertNotificationByAlertId(SourceDeviceAlertId: number): Observable<any> {
        const params = new HttpParams()
            .set("SourceDeviceAlertId", SourceDeviceAlertId)

        return this.http.get<any>(`${environment.urlBaseService}${Constants.GET_SOURCE_DEVICE_ALERT_NOTIFICATION_BY_ALERT_ID}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }

    GetContactsBySite(sitesId: string): Observable<any> {
        const params = new HttpParams()
            .set("sitesId", sitesId)

        return this.http.get<any>(`${environment.urlBaseService}${Constants.GET_CONTACTS_BY_SITE}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }

    GetAlertTypes(): Observable<any> {
        return this.http.get<any>(`${environment.urlBaseService}${Constants.GET_ALERT_TYPES}`)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }


    GetNotificationsConfiguration(): Observable<any> {
        return this.http.get<any>(`${environment.urlBaseService}${Constants.GET_NOTIFICATIONS_CONFIGURATION}`)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }

    GetSanityCheck(sitesId, localeCode): Observable<any> {
          const params = new HttpParams()
            .set("sitesId", sitesId)
            .set("localeCode", localeCode)

        return this.http.get<any>(`${environment.urlBaseService}${Constants.GET_SANITY_CHECK}`, { params })
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    let mensajeError = 'an error occurred while getting the data.';
                    if (error.status === 404) {
                        mensajeError = 'The requested resource was not found.';
                    }
                    return throwError(() => new Error(mensajeError));
                })
            )
    }
}
